import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Close32 } from "@carbon/icons-react";

class ComponentExtendedTeaserOverviewFilterText extends Component {
  state = {};

  render() {
    return (
      <section className="filter-text">
        <div className="container">
          <div className="row">
            <div className="col-16">
              {this.props.items.map((item, index) =>
                (() => {
                  switch (item.entityBundle) {
                    case "filtertext_text":
                      return <p key={index}>{item.fieldFilterTextText}</p>;
                    case "filtertext_filter":
                      return (
                        <div
                          className={classNames({
                            filter: true,
                            active:
                              this.props.activeFilter &&
                              this.props.activeFilter.id ===
                                item.fieldFilter.id,
                          })}
                          key={index}
                          onClick={() =>
                            this.props.changeActiveFilter(item.fieldFilter)
                          }
                        >
                          <span>
                            {item.fieldFilter.entityLabel}
                            {this.props.activeFilter &&
                              this.props.activeFilter.id ===
                                item.fieldFilter.id && <Close32 />}
                          </span>
                        </div>
                      );
                    default:
                      return null;
                  }
                })()
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ComponentExtendedTeaserOverviewFilterText.propTypes = {
  activeFilter: PropTypes.shape({
    id: PropTypes.string,
  }),
  changeActiveFilter: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      entityBundle: PropTypes.oneOf(["filtertext_text", "filtertext_filter"]),
      fieldFilterTextText: PropTypes.string,
      fieldFilter: PropTypes.shape({
        label: PropTypes.string,
        id: PropTypes.string,
      }),
    })
  ),
};

export default ComponentExtendedTeaserOverviewFilterText;
